<div class="text-start nestedbgcolor p-3 my-3">
  <p class="m-0 small"><span class="text-danger">{{ 'MISC.ATTENTION' | translate }}</span>: For RXT4500 OSA modules with
    <span class="fw-bold">SN prefix TS3</span>, please <span class="fw-bold">DO NOT UPGRADE</span> to
    new platform SW. This module is only compatible with <span class="fw-bold">RXT1200 SW 02.01.0008</span> and
    under. You may find that SW under <a class="d-inline p-0" routerLink="/support/software" queryParamsHandling="merge"
      [queryParams]="{ s: 'TS3' }">Support > Software Update</a>.</p>
</div>
